export const STOCK_REBATE_CDN = `${process.env.NEXT_PUBLIC_APP_OSS_PUBLIC_CND}/h5/activities/stock-rebate`;

/** 本地 public 资源，OSS 更新后可切回 CDN */
export const STOCK_REBATE_TESLA_COIN = "/h5/activities/stock-rebate/tesla-coin.svg";
